import { render } from "./ExportMarketplaces.vue?vue&type=template&id=3a5342c3"
import script from "./ExportMarketplaces.vue?vue&type=script&lang=js"
export * from "./ExportMarketplaces.vue?vue&type=script&lang=js"

import "./ExportMarketplaces.vue?vue&type=style&index=0&id=3a5342c3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__